// extracted by mini-css-extract-plugin
export default {"container":"style_container__PVYCo","questions":"style_questions__99bFn","submitDiv":"style_submitDiv__NsmpK"};